import { Text } from "@chakra-ui/react";


export default function WarningTextMessage({errorLogic, message, fontSize, textAlign}) {
		return (	
			<Text 
				display = {(errorLogic === true) ? '':'none'} 
				className={(errorLogic === true) ? "flip-in-hor-bottom" : ''} 
				fontSize={fontSize ? fontSize : '0.7em'} 
				color='brandPink.500'
				textAlign={textAlign ? textAlign : ''}
				whiteSpace='break-spaces'
			> 
				{message}
			</Text>
		)
}



